import { RawTradeButtonsComponent } from './tradeButtons';
import { connectConfirmingTradeButtons } from './tradeButtons.confirming.connect';
import { connectInitiatingTradeButtons } from './tradeButtons.initiating.connect';
import { RawConfirmTradeButtonsComponent, RawInitTradeButtonsComponent } from './tradeButtonsNext';

export const InitiateTradeButtonsComponent = connectInitiatingTradeButtons(RawTradeButtonsComponent);
InitiateTradeButtonsComponent.displayName = 'InitiateTradeButtonsComponent';

export const ConfirmTradeButtonsComponent = connectConfirmingTradeButtons(RawTradeButtonsComponent);
ConfirmTradeButtonsComponent.displayName = 'ConfirmTradeButtonsComponent';

export const InitiateTradeButtonsComponentNext = connectInitiatingTradeButtons(RawInitTradeButtonsComponent);
InitiateTradeButtonsComponentNext.displayName = 'InitiateTradeButtonsComponent';

export const ConfirmTradeButtonsComponentNext = connectConfirmingTradeButtons(RawConfirmTradeButtonsComponent);
ConfirmTradeButtonsComponentNext.displayName = 'ConfirmTradeButtonsComponent';
